module.exports = __webpack_public_path__ + "img/cross-close.a869d337.svg";